const fetchJSON = async (url, options = {}) => {
  const response = await fetch(url, options);
  if (!response.ok) {
    const error = await response.text();
    throw new Error(error);
  }
  return await response.json();
};

export const getUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const ApiService = (baseUrl) => ( {
  getMurs: () => {
    const user = getUser();
    const url =
      user && user.role === "USER"
        ? `${baseUrl}/MurDeBrique?userId=${user.id}`
        : `${baseUrl}/MurDeBrique`;

    return fetchJSON(url);
  },

  getMurById: (murId) => {
    const user = getUser();
    const url = 
      user && user.role === "USER"
        ? `${baseUrl}/MurDeBrique/${murId}`
        : `${baseUrl}/MurDeBrique/${murId}`;
    return fetchJSON(url);
  },

  createMur: (mur) =>
    fetchJSON(`${baseUrl}/MurDeBrique/ajouter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(mur),
    }),

  deleteMur: (murId) =>
    fetch(`${baseUrl}/MurDeBrique/${murId}`, { method: 'DELETE' }),

  ajouterForme: (forme) =>
    fetchJSON(`${baseUrl}/MurDeBrique/ajouter-forme`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(forme),
    }),

  supprimerForme: (murFormeId) =>
    fetch(`${baseUrl}/MurDeBrique/supprimer-formes/${murFormeId}`, {
      method: 'DELETE',
    }),

  updatePositionForme: (murFormeId, formeId, position) =>
    fetchJSON(`${baseUrl}/MurDeBrique/${murFormeId}/modifier-forme/${formeId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(position),
    }),

  getFormesDisponibles: () =>  fetchJSON(`${process.env.REACT_APP_API_ADMIN_URL}/formes`)
});
